import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  FDBox,
  FDContentContainer,
  FDDialog,
  FDDialogActions,
  FDDialogContent,
  FDDialogTitle,
  FDImage,
  FDPaper,
  FDPrimaryActionButton,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { ClickableTextRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ClickableTextRel';

export const GuidedHouseholdReviewOutroScheduleLayout = () => {
  const { resource } = useMetaLayoutContext();
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const startScheduler = async () => {
    setIsLoading(true);
    try {
      openModal(modalConsts.mcScheduler, [
        { link: resource.relationship(fr.relationships.scheduleMeeting.name).link('related').url() },
      ]);
      setShowConfirmation(false);
    } finally {
      setIsLoading(false);
    }
  };

  const scheduleButton = resource.withRelationship(fr.relationships.scheduleMeeting.name,
    (rel) => (
      <FDPrimaryActionButton
        {...dataAttrs('roadmap-explorer-schedule-meeting-button')}
        label={rel.meta('prompt')}
        onClick={() => setShowConfirmation(true)}
        loading={isLoading}
        alignSelf={'flex-start'}
        size="lg"
      />
    ),
    () => null);

  return (
    <FDContentContainer maxWidth="lg">
      <FDStack direction="row" justifyContent="space-between" spacing={8} alignItems={'center'}>
        <FDStack direction={'column'} spacing={3} width="50%">
          <FDDialog open={showConfirmation} onClose={() => setShowConfirmation(false)} maxWidth="sm">
            <FDDialogTitle value={resource.attr('confirmationTitle')} />
            <FDDialogContent>
              <MetaControlField attr="confirmationDescription" />
            </FDDialogContent>
            <FDDialogActions>
              <FDSecondaryActionButton onClick={() => setShowConfirmation(false)} label="Go back" />
              <FDPrimaryActionButton onClick={startScheduler} label="Leave and schedule" />
            </FDDialogActions>
          </FDDialog>
          <MetaControlField attr={'title'} />
          <MetaControlField attr={'subtitle'} />
          {scheduleButton}
          <ClickableTextRel appearance="standalone" relationship={resource.relationship(fr.relationships.bookLater.name)} />
        </FDStack>
        {resource.withRelationship(fr.relationships.image.name, (rel) => {
          return (
            <FDPaper padding={4} width={'65%'}>
              <FDBox paddingY={3}>
                <FDImage
                  width={'100%'}
                  alt={'Meeting schedule image'}
                  src={rel.link('related').url()}
                  {...dataAttrs('roadmap-explorer-schedule-meeting-image')}
                />
              </FDBox>
            </FDPaper>
          );
        }, () => null)}
      </FDStack>
    </FDContentContainer>
  );
};
